import { GroupSecurity } from '@quromedical/fhir-common';
import { withPermissions } from 'components/groups';
import { PatientCommunicationScreen } from 'screens/patient';

export default withPermissions(PatientCommunicationScreen, [
  GroupSecurity.CommunicationRead,
]);
